<div>
  <!-- Chat Icon -->
  <div class="chatbtn-section">
    <div class="chat-btn" (click)="toggleChat()">
      <img src="../../../assets/Krid/img/chat-icon.svg" alt="" />
    </div>
  </div>

  <!-- Chat Container -->
  <mat-card class="chat-container" *ngIf="isChatOpen">
    <div class="chat-section">
      <ul>
        <li>
          <div class="chat-content">
            <div class="d-flex align-items-center gap-2">
              <img src="../../../assets/Krid/img/chat-gpt-icon.jpg" alt="" />
              <h5>KRID AI</h5>
              <div class="icon-action">
                <ul>
                  <li (click)="createNewChat()" *ngIf="chat.length > 0" class="cursor-pointer" title="New Chat">
                    <img src="../../../assets/Krid/img/refresh-chat.svg" class="cursor-pointer" alt="" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="chat-content inner" #chatBoxInner>
            <div class="d-flex gap-2">
              <img src="../../../assets/Krid/img/chat-gpt-icon.jpg" alt="" srcset="">
              <p class="assistance-chat">Hello! It's nice to meet you. Is there something I can help you with, or would you like to chat?</p>
            </div>
            <ng-container *ngFor="let item of chat" >
              <div class="d-flex ">
                <img src="../../../assets/Krid/img/chat-gpt-icon.jpg" class="me-1"  *ngIf="item.role != 'user'" alt="" srcset="">
                <p  [ngClass]="item.role == 'user' ? 'user-chat' : 'assistance-chat'"
                [innerHTML]="item.content"></p>
                <img [src]="userImage ? userImage : '../../../assets/img/default-user-profile.svg'"alt="Profile Picture" class="ai-image ms-1" *ngIf="item.role == 'user'" (error)="handleImageError()" />
              </div>
              </ng-container>
            <p *ngIf="chat.length == 0">{{ response }}</p>

          </div>
        </li>
      </ul>
    </div>
    <div class="chat-input">
      <mat-form-field>
        <textarea matInput [(ngModel)]="userInput" (keydown.enter)="sendMessage()" placeholder="Message ChatGPT"
          rows="4"></textarea>
        <button mat-raised-button color="primary" type="submit" (click)="sendMessage()">
          <i class="fa-solid fa-arrow-up"></i>
        </button>
      </mat-form-field>
    </div>
  </mat-card>
</div>